import { all, fork } from "redux-saga/effects";
import { authRootSaga } from "./auth/authSagas";
import { lobbyRootSaga } from "./lobby/lobbySagas";
import { roomSocketSaga } from "./room/roomSagas";
import { packageRootSaga } from "./packages/packagesSagas";
import { bonusRootSaga } from "./bonus/bonusSagas";
import { i18nRootSaga } from "./i18n/i18nSagas";
import { notificationsRootSaga } from "./userNotifications/notificationsSagas";
import { inviteRootSaga } from "./invites/inviteSaga";
import { rankingsRootSaga } from "./rankings/rankingsSagas";
import { tournamentsRootSaga } from "./tournaments/tournamentsSagas";
import { miniGamesRootSaga } from "./miniGames/miniGamesSagas";
import { miniGamesRewardsRootSaga } from "./jackpot/miniGamesRewardsSaga";
import { iapSaga } from "./iap/iapSagas";
import { adRewardRootSaga } from "./adReward/adRewardSagas";

export function* rootSaga() {
  yield all([
    fork(roomSocketSaga),
    fork(authRootSaga),
    fork(lobbyRootSaga),
    fork(packageRootSaga),
    fork(bonusRootSaga),
    fork(i18nRootSaga),
    fork(notificationsRootSaga),
    fork(inviteRootSaga),
    fork(rankingsRootSaga),
    fork(tournamentsRootSaga),
    fork(miniGamesRootSaga),
    fork(miniGamesRewardsRootSaga),
    fork(iapSaga),
    fork(adRewardRootSaga),
  ]);
}
